import { takeFmpHomeInfoHandoff } from '@strata-monorepo/utils/fmpHomeInfoHandoff'
import type { FmpHomeInfoHandoff } from '@strata-monorepo/utils/fmpHomeInfoHandoff'
import type { FormStepResult } from '../types'

// Read once per page load and kept: the store and the questionnaire both need it, and React's
// development double render would otherwise find the one-time hand-off already gone
let cachedHandoff: FmpHomeInfoHandoff | null | undefined

/** The hand-off Strata's plan-details address block left for the home details step, if any. */
export function getHomeInfoHandoff(): FmpHomeInfoHandoff | null {
  if (cachedHandoff === undefined) cachedHandoff = takeFmpHomeInfoHandoff()
  return cachedHandoff
}

/**
 * The host's answers with the handed-off address in place. The hand-off wins over a host address:
 * it is the address the shopper just picked. `enriched: false` matches what FMP's own address
 * step records when the lookup didn't return full home details.
 */
export function withHomeInfoHandoff(formResults: FormStepResult): FormStepResult {
  const handoff = getHomeInfoHandoff()
  if (!handoff) return formResults

  return { ...formResults, address: { ...handoff.address, enriched: false } }
}

/** Forget the cached hand-off; for tests. */
export function resetHomeInfoHandoff(): void {
  cachedHandoff = undefined
}
